import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  useTheme
} from "@mui/material";
import { captureContactClick } from "../analytics";

// Animated link style with underline that grows from center
const animatedLinkStyle = (theme) => ({
  position: 'relative',
  textDecoration: 'none',
  // tap-target floor: these were 24px tall
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: 44,
  px: 1,
  color: theme.palette.text.secondary,
  transition: 'color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 8,
    left: '50%',
    width: 0,
    height: 2,
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'translateX(-50%)',
    borderRadius: 1,
  },
  '&:hover': {
    color: theme.palette.primary.main,
    '&::after': {
      width: '100%',
    },
  },
});

function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        textAlign: "center",
        // Opaque, no backdrop blur — see Navigation: nothing passes behind it.
        backgroundColor: theme.palette.background.default,
        borderTop: `1px solid ${theme.palette.divider}`
      }}
    >
      <Stack 
        direction={{ xs: "column", sm: "row" }} 
        spacing={{ xs: 2, sm: 3 }} 
        justifyContent="center" 
        alignItems="center"
        sx={{ mb: 2 }}
      >
        {/* First position, on every page: cold evaluators who won't fill in a
            form need an address they can see without navigating anywhere. */}
        <Box
          component="a"
          href="mailto:hello@skylarkcreations.com"
          onClick={() => captureContactClick("footer")}
          sx={animatedLinkStyle(theme)}
        >
          hello@skylarkcreations.com
        </Box>
        <Box
          component="a"
          href="https://skylarkcreations.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={animatedLinkStyle(theme)}
        >
          Skylark Creations
        </Box>
        <Box
          component="a"
          href="https://uncagedminds.substack.com" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={animatedLinkStyle(theme)}
        >
          Uncaged Minds
        </Box>

        <Box
          component={RouterLink}
          to="/privacy"
          sx={animatedLinkStyle(theme)}
        >
          Privacy Policy
        </Box>
        <Box
          component={RouterLink}
          to="/terms"
          sx={animatedLinkStyle(theme)}
        >
          Terms of Service
        </Box>
      </Stack>
      
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} David Kooi. All rights reserved.
      </Typography>
    </Box>
  );
}

export default Footer;
